/* Candywrap Pick & Mix v2 indeling (ontwerp NwPickMix). Raakt de bouwer-logica niet aan:
   - stap 1 en 2 staan allebei in beeld, met genummerde koppen
   - het overzicht staat rechts naast beide stappen (wordt verplaatst, blijft binnen de bouwer)
   - Jouw selectie verschijnt pas na het kiezen van een verpakking
   - filters zitten achter de Filter-knop, ook op desktop */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.__cwPnm) return;
    var box = root.querySelector('[data-format-choices]');
    if (!box || !box.querySelector('.pnm-choice')) { setTimeout(function () { init(root); }, 120); return; }
    root.__cwPnm = true;
    root.classList.add('cw-pnm2');

    var p1 = root.querySelector('[data-panel="1"]'), p2 = root.querySelector('[data-panel="2"]');
    [[p1, 1], [p2, 2]].forEach(function (x) {
      var h = x[0] && x[0].querySelector(':scope > h3');
      if (h && !h.querySelector('.cw-pnm-n')) h.insertAdjacentHTML('afterbegin', '<span class="cw-pnm-n">' + x[1] + '</span>');
    });

    /* overzicht rechts naast beide stappen */
    var wrap = root.querySelector('.pnm-wrap'), aside = root.querySelector('.pnm-summary');
    if (wrap && aside && p1 && p2) {
      var grid = document.createElement('div'); grid.className = 'cw-pnm-grid';
      var main = document.createElement('div'); main.className = 'cw-pnm-main';
      p1.parentNode.insertBefore(grid, p1);
      main.appendChild(p1); main.appendChild(p2);
      grid.appendChild(main); grid.appendChild(aside);
    }

    /* snoep op populariteit: meest verkocht de afgelopen 28 dagen eerst, daarna totaal */
    var grid0 = root.querySelector('.pnm-grid');
    if (grid0) {
      var num = function (el, k) { return parseFloat(el.getAttribute(k)) || 0; };
      Array.prototype.slice.call(grid0.querySelectorAll(':scope > .pnm-candy'))
        .sort(function (a, b) { return (num(b, 'data-s28') - num(a, 'data-s28')) || (num(b, 'data-sales') - num(a, 'data-sales')); })
        .forEach(function (el) { grid0.appendChild(el); });
    }

    /* geen verpakking voorkiezen; Jouw selectie pas tonen als er een verpakking gekozen is */
    var sync = function () { root.classList.toggle('cw-pnm-nopkg', !box.querySelector('.pnm-choice.is-selected')); };
    sync();
    box.addEventListener('click', function () { setTimeout(sync, 30); });
    new MutationObserver(sync).observe(box, { subtree: true, attributes: true, attributeFilter: ['class'] });
    /* later van verpakking wisselen: niet naar boven springen */
    root.scrollIntoView = function () {};
  }
  function boot() { document.querySelectorAll('[data-pnm]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();

/* Jouw selectie: lege vakjes met vraagteken tot het aantal porties (max 16), zodat je meteen ziet hoeveel je nog kiest */
(function () {
  function fill(root) {
    var slots = root.querySelector('.pnm-slots'), cnt = root.querySelector('.pnm-count');
    if (!slots || !cnt) return;
    var m = cnt.textContent.match(/(\d+)\s*\/\s*(\d+)/); if (!m) return;
    var max = parseInt(m[2], 10);
    slots.querySelectorAll('.cw-slot-q').forEach(function (e) { e.remove(); });
    if (max > 16) { slots.classList.remove('cw-has-q'); return; }
    var filled = slots.querySelectorAll('.pnm-slot').length;
    var empty = slots.querySelector('.pnm-empty'); if (empty) empty.style.display = 'none';
    for (var i = filled; i < max; i++) { var s = document.createElement('span'); s.className = 'cw-slot-q'; s.textContent = '?'; slots.appendChild(s); }
    slots.classList.add('cw-has-q');
  }
  function watch(root) {
    var slots = root.querySelector('.pnm-slots'); if (!slots || slots.__cwq) return; slots.__cwq = true;
    var busy = false;
    var mo = new MutationObserver(function () { if (busy) return; busy = true; fill(root); setTimeout(function () { busy = false; }, 0); });
    mo.observe(slots, { childList: true });
    var cnt = root.querySelector('.pnm-count'); if (cnt) new MutationObserver(function () { if (!busy) { busy = true; fill(root); setTimeout(function () { busy = false; }, 0); } }).observe(cnt, { childList: true, characterData: true, subtree: true });
    fill(root);
  }
  function boot() { document.querySelectorAll('[data-pnm]').forEach(function (r) { var t = setInterval(function () { if (r.querySelector('.pnm-slots')) { clearInterval(t); watch(r); } }, 200); }); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();


/* Kleiner bakje gekozen: alleen de eerste porties houden (van achteren weghalen via de eigen verwijderknoppen van de bouwer) */
(function () {
  function counts(root) { var c = root.querySelector('.pnm-count'); var m = c && c.textContent.match(/(\d+)\s*\/\s*(\d+)/); return m ? [parseInt(m[1], 10), parseInt(m[2], 10)] : null; }
  /* wat bij een kleiner bakje is weggehaald, onthouden we (in volgorde) en zetten we terug bij een groter bakje */
  function stash(root) { return root.__cwStash || (root.__cwStash = []); }
  function trim(root, guard) {
    var c = counts(root); if (!c || c[0] <= c[1] || guard > 400) return;
    var xs = root.querySelectorAll('.pnm-slots .pnm-slot-x'); if (!xs.length) return;
    var last = xs[xs.length - 1];
    stash(root).unshift(last.getAttribute('data-rm'));
    last.click();
    setTimeout(function () { trim(root, (guard || 0) + 1); }, 0);
  }
  function restore(root, guard) {
    var c = counts(root), st = stash(root); if (!c || c[0] >= c[1] || !st.length || guard > 400) return;
    var id = st.shift();
    var plus = root.querySelector('.pnm-candy[data-variant="' + id + '"] [data-plus], .pnm-candy[data-portion-variant="' + id + '"] [data-plus]');
    if (plus && !plus.disabled) plus.click();
    setTimeout(function () { restore(root, (guard || 0) + 1); }, 0);
  }
  document.addEventListener('click', function (e) {
    var ch = e.target.closest && e.target.closest('.pnm-choice'); if (!ch) return;
    var root = ch.closest('[data-pnm]');
    setTimeout(function () { var c = counts(root); if (!c) return; if (c[0] > c[1]) trim(root, 0); else restore(root, 0); }, 60);
  });
})();

/* Snelfilters onder de zoekbalk: Alles, Zoet, Zuur, Zoet & zuur, Drop, Halal (een tegelijk, bovenop zoeken en filters) */
(function () {
  var QF = [['', 'Alles'], ['zoet', 'Zoet'], ['zuur', 'Zuur'], ['zoetzuur', 'Zoet & zuur'], ['drop', 'Drop'], ['halal', 'Halal']];
  function vals(el, k) { return (el.getAttribute('data-' + k) || '').toLowerCase().split('|').map(function (s) { return s.trim(); }); }
  function match(el, q) {
    if (!q) return true;
    if (q === 'halal') return vals(el, 'diet').indexOf('halal') > -1;
    var s = vals(el, 'smaak');
    if (q === 'zoetzuur') return s.indexOf('zoetzuur') > -1 || (s.indexOf('zoet') > -1 && s.indexOf('zuur') > -1);
    if (q === 'drop') return s.indexOf('drop') > -1 || s.indexOf('salmiak') > -1;
    return s.indexOf(q) > -1;
  }
  function init(root) {
    var bar = root.querySelector('.pnm-toolbar'); if (!bar || root.__cwQf) return; root.__cwQf = true;
    var row = document.createElement('div'); row.className = 'cw-qf'; row.setAttribute('role', 'group'); row.setAttribute('aria-label', 'Snelfilters');
    row.innerHTML = QF.map(function (x, i) { return '<button type="button" class="cw-qf-b' + (i ? '' : ' on') + '" data-qf="' + x[0] + '" aria-pressed="' + (i ? 'false' : 'true') + '">' + x[1].replace('&', '&amp;') + '</button>'; }).join('');
    bar.parentNode.insertBefore(row, bar.nextSibling);
    var cur = '';
    function apply() { root.querySelectorAll('.pnm-candy').forEach(function (el) { el.classList.toggle('cw-qf-hide', !match(el, cur)); }); }
    row.addEventListener('click', function (e) {
      var b = e.target.closest('.cw-qf-b'); if (!b) return;
      cur = b.getAttribute('data-qf');
      row.querySelectorAll('.cw-qf-b').forEach(function (x) { var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      apply();
    });
  }
  function boot() { document.querySelectorAll('[data-pnm]').forEach(function (r) { var t = setInterval(function () { if (r.querySelector('.pnm-toolbar') && r.querySelector('.pnm-candy')) { clearInterval(t); init(r); } }, 200); }); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
